import React from 'react';
import {Image} from 'antd-mobile';
import {ReactComponent as CorncobIcon} from '@/assets/icons/sports/corncob.svg';
import {ReactComponent as PointIcon} from '@/assets/icons/sports/point.svg';
import HotItem from './hot-item';
export type SportsType =
  | 'Cricket'
  | 'Football'
  | 'Basketball'
  | 'Volleyball'
  | 'CyberSport'
  | 'League'
  | 'Matches'
  | 'Tennis'
  | 'Australian-Football'
  | 'Badminton'
  | 'UFC';

export interface VsItem {
  teamName: string;
  teamPic: string;
  cricketIconType?: 'corncob' | 'point';
}

export interface SportsItem {
  title: string;
  vs: VsItem[];
  // INNINGS 1
  vsType?: string;
  leagueTime?: string;
  leagueTimeBase?: number;
  // 左右比分相关
  vsRedScore?: string;
  vsScore?: string;
  uri?: string;
  // 是否是直播
  isLive?: boolean;
  // 体育事件id（包含体育、联赛、赛事、分类、体育事件id）
  completeEventId?: string;
  sport?: string;
  // Market列表
  marketList?: {
    price: string;
    outcomeName: string;
  }[];
}

export interface SportsCategory {
  title: string;
  icon: string;
  type: SportsType;
  allLive?: boolean;
  list: SportsItem[];
}

export interface SportSwiperItemProps {
  item: SportsItem;
  isLive?: boolean;
  isSport?: boolean;
  defaultClass?: string;
  isMix?: boolean;
  icon?: string;
}

interface HotLeagueTeamItemProps {
  teamName: string;
  teamPic?: string;
  redScore?: string;
  score?: string;
  maxLength?: {
    width: string;
  };
  maxRl?: {
    width: string;
  };
  defaultIcon?: string;
}

const HotLeagueTeamItem = ({
  teamName,
  teamPic,
  redScore,
  score,
  maxLength,
  maxRl,
  defaultIcon,
}: HotLeagueTeamItemProps) => {
  // const maxLength = Math.max(redScore?.length || 0, score?.length || 0);
  // console.log(maxLength);
  // const maxLengthStyle = {
  //   width: `${maxLength * 0.875}rem`,
  // };
  return (
    <div className="flex flex-row items-center gap-0">
      <div className="flex-1 flex flex-row items-center overflow-hidden h-[30px]">
        <Image
          src={teamPic}
          // todo
          // 这个默认图片 占位图是否需要调整
          fallback={
            defaultIcon ? (
              <Image src={defaultIcon} className="size-5" />
            ) : (
              <div className="size-5 bg-red-300" />
            )
          }
          className="size-5"
        />
        <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap pl-1 text-[.875rem]">
          {teamName}
        </span>
        <div className="flex flex-row items-center">
          {redScore && (
            // 长度取redScore的最长的
            <span
              className="text-t3 text-[.75rem] flex items-center justify-center leading-[30px]"
              style={maxLength}>
              {redScore}
            </span>
          )}
          {score && (
            <span
              className="text-[.875rem] font-bold text-[#E61514] ml-2 flex items-end justify-end leading-[30px]"
              style={maxRl}>
              {score}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const MiddleContent = ({
  item,
  isLive,
  isSport,
  isMix,
  icon,
}: {
  isLive?: boolean;
  isSport?: boolean;
  item: SportsItem;
  isMix?: boolean;
  icon?: string;
}) => {
  // item.vs redScore最长的长度
  // item?.vsRedScore?.split(':')数组最长
  const maxLength = Math.max(
    ...(item?.vsRedScore?.split(':') || []).map(redcord => redcord.length),
  );
  const maxLengthStyle = {
    width: `${maxLength * 0.4}rem`,
  };
  const maxRl = Math.max(
    ...(item.vsScore?.split(':') || []).map(score => score.length),
  );
  const maxRlStyle = {
    width: `${maxRl * 0.55}rem`,
  };
  // const maxLength = Math.max(item?.vsRedScore?.split(':'));
  // console.log(item);
  if (!isSport && isLive) {
    return (
      <div className={`flex flex-col ${isMix ? 'h-[5rem]' : ''}`}>
        <div className="pl-2 pr-2">
          <span className="text-[.625rem] leading-3 mb-2 text-[#E61514] ">
            {item.vsType}
          </span>
        </div>
        <div className="flex flex-col pl-2 pr-2">
          {item.vs.map((_item, _index) => (
            <HotLeagueTeamItem
              teamPic={_item.teamPic}
              teamName={_item.teamName}
              key={_index}
              redScore={
                item?.vsRedScore && item?.vsRedScore?.split(':')[_index]
              }
              score={item?.vsScore && item?.vsScore?.split(':')[_index]}
              maxLength={maxLengthStyle}
              maxRl={maxRlStyle}
              defaultIcon={icon}
            />
          ))}
        </div>
      </div>
    );
  }
  return isLive ? (
    <div
      className={`flex flex-row w-full gap-1 items-center pl-2 pr-2 ${
        isMix ? 'h-[5rem]' : ''
      }`}>
      <div className="w-[5.125rem] flex flex-col items-center gap-1 ">
        <Image
          src={item.vs[0].teamPic}
          fallback={icon ? <Image src={icon} className="size-10" /> : undefined}
          className="size-10"
        />
        <span className="w-full text-t1 text-center overflow-hidden text-ellipsis whitespace-nowrap">
          {item.vs[0].teamName}
        </span>
      </div>
      <div className="flex-1 flex flex-col gap-1 items-center">
        <span className="text-[var(--sports--1)] text-[.625rem] leading-3 uppercase">
          {item.vsType}
        </span>
        <div className="text-t1 text-lg font-bold flex flex-row gap-1 items-center">
          {item.vs[0].cricketIconType ? (
            item.vs[0].cricketIconType === 'corncob' ? (
              <CorncobIcon className="size-3 text-t3" />
            ) : (
              <PointIcon className="size-3 text-t3" />
            )
          ) : null}
          <span className="leading-[1.375rem]">{item.vsScore}</span>
          {/* 第三个如果有cricketIconType。才展示 */}
          {item.vs[1].cricketIconType ? (
            item.vs[1].cricketIconType === 'corncob' ? (
              <CorncobIcon className="size-3 text-t3" />
            ) : (
              <PointIcon className="size-3 text-t3" />
            )
          ) : null}
        </div>
        <span className="text-[var(--sports--1)] text-[.625rem] leading-3">
          {item.vsRedScore}
        </span>
      </div>
      <div className="w-[5.125rem] flex flex-col items-center gap-1">
        <Image
          src={item.vs[1].teamPic}
          fallback={icon ? <Image src={icon} className="size-10" /> : undefined}
          className="size-10"
        />
        <span className="w-full text-t1 text-center overflow-hidden text-ellipsis whitespace-nowrap">
          {item.vs[1].teamName}
        </span>
      </div>
    </div>
  ) : (
    <div className={`flex flex-col px-2 ${isMix ? 'h-[5rem]' : ''}`}>
      <span className="text-t3 text-[.625rem] leading-3 mb-2 text-[#E61514]">
        {item.leagueTime}
      </span>
      {item.vs.map((_item, _index) => (
        <HotLeagueTeamItem
          teamPic={_item.teamPic}
          teamName={_item.teamName}
          // redScore={item?.vsRedScore && item?.vsRedScore?.split(':')[_index]}
          // score={item?.vsScore && item?.vsScore?.split(':')[_index]}
          key={_index}
        />
      ))}
    </div>
  );
};

const SportSwiperCard = ({
  item,
  isLive,
  isSport,
  defaultClass,
  isMix,
  icon,
}: SportSwiperItemProps) => {
  return (
    <HotItem
      title={item.title}
      uri={item.uri}
      className={`${defaultClass} bg-white`}
      middleContent={
        <MiddleContent
          item={item}
          isLive={isLive}
          isSport={isSport}
          isMix={isMix}
          icon={icon}
        />
      }
      vsType={item.vsType}
      marketList={item.marketList}
    />
  );
};

export default SportSwiperCard;
